import { constructMetadata } from "../shared/index.js";
const withMetadata = (args, accessId) => {
  if (accessId) {
    args.push(constructMetadata({ accessId }));
  }
  return args;
};
export {
  withMetadata
};
//# sourceMappingURL=uiCommands.js.map